import styled from 'styled-components';

export const SVGButton = styled.svg`
font-size: 13pt;
cursor: pointer;
margin-left: 5px;
margin-right: 5px;
 &:hover {
    path {
    stroke: var(--secondary);
    }
    g {
    stroke: var(--secondary);
    }
}
`;
